<template>
  <fieldset class="tab tab-08">
    <div class="heading-form a-center">
      <span class="number">8/11</span>
      <p class="c-yellow">ไลฟ์สไตล์ของคุณ</p>
      <h2 class="heading-h2 c-white">คุณใช้อุปกรณ์ตรวจวัดสุขภาพใดบ้าง</h2>
      <p class="desc">(เลือกได้มากกว่า 1 ข้อ)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div
            class="icw-input icw-input-checkbox icon-none icw-input-full c-lifestyle"
          >
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="fitbit"
                class="css-checkbox"
                :value="'fitbit'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="fitbit" class="css-label">
                <div class="img-fitbit"></div>
                ฟิตบิท
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="garmin"
                class="css-checkbox"
                :value="'garmin'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="garmin" class="css-label">
                <div class="img-garmin"></div>
                การ์มิน
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="samsunggear"
                class="css-checkbox"
                :value="'ssgear'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="samsunggear" class="css-label">
                <div class="img-samsunggear"></div>
                ซัมซุง เกียร์
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="applewatch"
                class="css-checkbox"
                :value="'applewatch'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="applewatch" class="css-label">
                <div class="img-applewatch"></div>
                แอปเปิ้ลวอทช์
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="huawei"
                class="css-checkbox"
                :value="'huawei'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="huawei" class="css-label">
                <div class="img-huawei"></div>
                หัวเว่ย
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="xiaomi"
                class="css-checkbox"
                :value="'xiomi'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="xiaomi" class="css-label">
                <div class="img-xiaomi"></div>
                เสียวหมี่
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="appication"
                class="css-checkbox"
                :value="'mobileapp'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="appication" class="css-label">
                <i class="ic ic-app"></i>แอปพลิเคชันบนมือถือ
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="other3"
                class="css-checkbox more-gadget"
                :value="'etc'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="other3" class="css-label">
                <i class="ic ic-other"></i
                >{{ gadget_etc.trim() != "" ? gadget_etc : "อื่นๆ" }}
              </label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle3"
                id="nouse"
                class="css-checkbox"
                :value="'-1'"
                v-model="gadget"
                @change="checkValue($event)"
              />
              <label for="nouse" class="css-label">
                <i class="ic ic-no"></i>ไม่ใช้
              </label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-08', 'tab-07')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ9"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a
      href="#popup-input-gadget"
      class="popup-input-gadget"
      style="display: none;"
      >click me</a
    >
    <div id="popup-input-gadget" class="mfp-hide modal-input">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">อุปกรณ์อื่นๆ</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <input
                          type="text"
                          placeholder="โปรดระบุ"
                          name="lifestyle_etc"
                          v-model="gadget_etc"
                          maxlength="100"
                        />
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          type="button"
                          class="btn"
                          @click="ConfJobText()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep1_Q8",
  props: {
    QuestionType: String
  },
  data() {
    return {
      gadget:
        my_storage(this.QuestionType, "gadget") == ""
          ? []
          : my_storage(this.QuestionType, "gadget"),
      gadget_etc: my_storage(this.QuestionType, "gadget_etc")
    };
  },
  mounted() {
    this.checkValue();

    this.$nextTick(() => {
      $(".popup-input-gadget").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".more-gadget").click(function() {
        $(".popup-input-gadget").trigger("click");
      });

      let self = this;
      $(".popup-input-gadget").on("mfpClose", function() {
        if (
          $("input[name=lifestyle_etc]")
            .val()
            .trim() == ""
        ) {
          self.gadget.splice(self.gadget.indexOf("etc"), 1);
          $("input[type=checkbox][value=etc]").prop("checked", false);
        } else {
          if (self.gadget.indexOf("etc") == -1) {
            self.gadget.push("etc");
          }
          $("input[type=checkbox][value=etc]").prop("checked", true);
        }
      });
    });
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    ConfJobText() {
      if (this.gadget_etc.trim() != "") {
        $.magnificPopup.close();
      }
    },
    beforeNextStep() {
      let pass = false;
      if (this.gadget.length > 0) {
        if (this.gadget.indexOf("etc") > -1 && this.gadget_etc.trim() != "") {
          pass = true;
        } else if (this.gadget.indexOf("etc") == -1) {
          pass = true;
        }
      }

      if (pass) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;

        this.nextStep("tab-08", "tab-09");
      }
    },
    checkValue(event) {
      if (this.gadget.indexOf("-1") > -1) {
        this.gadget = ["-1"];
        this.gadget_etc = "";
        $(this.$el)
          .find(".checkbox.checkbox-inline")
          .each(function() {
            if (
              $(this)
                .find("input[type=checkbox]")
                .val() != "-1"
            ) {
              $(this)
                .find("input[type=checkbox]")
                .prop("disabled", true);
            }
          });
      } else if (this.gadget.indexOf("-1") == -1) {
        $(this.$el)
          .find(".checkbox.checkbox-inline")
          .each(function() {
            $(this)
              .find("input[type=checkbox]")
              .prop("disabled", false);
          });
      }
    }
  },
  computed: {
    isPass() {
      let pass = false;
      if (this.gadget.length > 0) {
        if (this.gadget.indexOf("etc") > -1 && this.gadget_etc.trim() != "") {
          pass = true;
        } else if (this.gadget.indexOf("etc") == -1) {
          pass = true;
        }
      }

      return pass;
    }
  }
};
</script>
